// src/hooks/useAppointmentForm.ts
import { useState, useCallback, useEffect } from "react";
import {
  Appointment_form,
  AppointmentFormData,
  Patient,
  Service,
} from "../interfaces/types";

// Define the default state for a new appointment
const defaultPatient: Patient = {
  id: "",
  name: "Paciente sin asignar",
  email: "",
  phone: "",
};
const defaultService: Service = {
  id: "",
  name: "",
  number: "",
  title: "",
  categorySlug: "",
  categoryName: "",
  description: "",
  duration_minutes: 0,
  mode: "",
  price: "",
  status: false,
};

const defaultFormData: AppointmentFormData = {
  id: "",
  title: "Nueva Cita",
  status: "pending",
  service: defaultService,
  duration: "60min",
  date: new Date().toISOString().split("T")[0],
  time: "09:00",
  end_time: "10:00", // Added default end_time
  start_time: "09:00",
  location: "Consultorio A",
  type: "Presencial",
  reason: "Evaluación Inicial",
  notes: "",
  office: "",
  patient: defaultPatient,
};

export const useAppointmentForm = (initialAppointment?: Appointment_form) => {
  const [formData, setFormData] = useState<AppointmentFormData>(
    initialAppointment ? { ...initialAppointment } : defaultFormData,
  );

  // Synchronize internal state when initialAppointment prop changes
  useEffect(() => {
    if (initialAppointment) {
      setFormData({ ...initialAppointment });
    } else {
      setFormData(defaultFormData);
    }
  }, [initialAppointment]);

  const handleChange = useCallback(
    (
      e: React.ChangeEvent<
        HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
      >,
    ) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    },
    [],
  );

  const isEditMode = !!initialAppointment;
  return {
    formData,
    handleChange,
    setFormData, // Export setFormData for external manipulation
    isEditMode,
    patient: formData.patient,
  };
};
